import React, { useEffect, useState } from "react";
import { GoogleMapsOverlay } from "@deck.gl/google-maps";
import { IconLayer, PathLayer } from "@deck.gl/layers";
import { PathStyleExtension } from "@deck.gl/extensions";

import "./DeckGLGoogleMap.scss";

import YouAreHereSVG from "app/assets/you-are-here.svg";
import StoreSVG from "app/assets/store.svg";

const ICON_LOGO = {
  marker: { x: -37, y: -18, width: 128, height: 128, mask: false },
};

/*eslint-disable no-undef*/
const DeckGLGoogleMap = ({
  centerCoordinate,
  branches,
  selectedBranch,
  currentAddress,
}) => {
  const [map, setMap] = useState(null);
  useEffect(() => {
    async function loadMap() {
      setMap(
        new google.maps.Map(document.getElementById("google-maps"), {
          center: { lat: 14.5829431, lng: 121.0519854 },
          zoom: 13,
        })
      );
    }

    if (!map) {
      loadMap();
    }
  }, [map]);

  const [overlay, setOverlay] = useState(null);
  useEffect(() => {
    if (map) {
      if (overlay) {
        overlay.setMap(map);
      } else {
        setOverlay(new GoogleMapsOverlay());
      }
    }
  }, [overlay, map]);

  useEffect(() => {
    if (map && overlay) {
      if (branches && branches.result.length > 0) {
        let line = null;

        if (selectedBranch) {
          line = new PathLayer({
            id: "path-layer",
            data: [
              {
                name: {
                  from: currentAddress,
                  to: selectedBranch.name,
                },
                path: [
                  [centerCoordinate.longitude, centerCoordinate.latitude],
                  [
                    selectedBranch.coordinates[0],
                    selectedBranch.coordinates[1],
                  ],
                ],
              },
            ],
            getDashArray: [3, 2],
            // dashJustified: true,
            extensions: [
              new PathStyleExtension({
                dash: true,
              }),
            ],
            // getDashArray: [1, 2],
            getPath: (d) => d.path,
            getWidth: 10,
            getColor: (d) => [235, 52, 54],
            pickable: true,
          });
        }

        overlay.setProps({
          getTooltip: (d) => {
            if (d.object) {
              return {
                html: `<div><div>From: ${d.object.name.from}</div><div>To: ${d.object.name.to}</div></div>`,
                style: {
                  zIndex: 1,
                  position: "absolute",
                  color: "#a0a7b4",
                  backgroundColor: "#29323c",
                  padding: "10px",
                  width: "200px",
                },
              };
            }
          },
          layers: [
            line,

            new IconLayer({
              id: "branch-icon",
              data: branches.result.map((branchId) => branches.data[branchId]),
              iconAtlas: StoreSVG,
              iconMapping: ICON_LOGO,
              getIcon: (d) => "marker",
              getPosition: (d) => d.coordinates,
              getSize: (d) => 175,
              iconSize: 50,
            }),
            new IconLayer({
              id: "center-icon",
              data: [
                {
                  coordinates: [
                    centerCoordinate.longitude,
                    centerCoordinate.latitude,
                  ],
                },
              ],
              iconAtlas: YouAreHereSVG,
              iconMapping: {
                marker: { x: -32, y: 0, width: 128, height: 128, mask: false },
              },
              getIcon: (d) => "marker",
              getPosition: (d) => d.coordinates,
              getSize: (d) => 225,
              // getColor: d => [255, 255, 255],
              // getColor: d => [235, 36, 38],
              // autoHighlight: true,
              // highlightColor: [255, 255, 255],
              // pickable: true,
              iconSize: 50,
            }),
          ],
        });

        const latLonList = branches.result.map((branchId) => {
          const branch = branches.data[branchId];
          return new google.maps.LatLng(
            branch.coordinates[1],
            branch.coordinates[0]
          );
        });

        latLonList.push(
          new google.maps.LatLng(
            centerCoordinate.latitude,
            centerCoordinate.longitude
          )
        );

        const bounds = new google.maps.LatLngBounds();

        latLonList.forEach((branchCoordinate) => {
          bounds.extend(branchCoordinate);
        });

        const boundedMap = map;
        boundedMap.fitBounds(bounds);

        const listener = google.maps.event.addListener(
          boundedMap,
          "idle",
          function () {
            if (boundedMap.getZoom() > 16 && !selectedBranch)
              boundedMap.setZoom(16);
            google.maps.event.removeListener(listener);
          }
        );

        setMap(boundedMap);
      }
    }
  }, [
    branches,
    overlay,
    map,
    centerCoordinate,
    selectedBranch,
    currentAddress,
  ]);

  useEffect(() => {
    if (map && selectedBranch && map) {
      const latLonList = [
        new google.maps.LatLng(
          selectedBranch.coordinates[1],
          selectedBranch.coordinates[0]
        ),
        new google.maps.LatLng(
          centerCoordinate.latitude,
          centerCoordinate.longitude
        ),
      ];

      const bounds = new google.maps.LatLngBounds();

      latLonList.forEach((coordinate) => {
        bounds.extend(coordinate);
      });

      const boundedMap = map;

      boundedMap.fitBounds(bounds);

      setMap(boundedMap);
    }
  }, [centerCoordinate, selectedBranch, map]);

  return <div id="google-maps" className="google-maps" />;
};

export default DeckGLGoogleMap;
